<template>
  <!-- height: 1165px;background: #fafbff; -->
  <!-- <el-footer class="footer-div center"> -->
  <!-- :style="{
        backgroundImage:
          'url(' +
          $domain +
          'static/noten/website/home/index1_bottom_bg.png' +
          ')'
      }" -->
  <div class="name">
    <Intro></Intro>
  </div>
  <!-- </el-footer> -->
</template>

<script>
import Intro from "@/components/Intro";
export default {
  components: { Intro },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.footer-div {
  // background-color: #ffffff !important;
  // height: auto;
  // height: 100px;
  // width: 900px;
  // background: aqua;
  // // position: relative;
  // background: #fafbff;
}
.name {
  // position: relative;
  // // bottom: 0px;
  height: 60px;
  // padding: 0;
  width: 100%;
  // height: 360px;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue